module.exports = __webpack_public_path__ + "static/media/info_paciente_icon5.de65e389.svg";